export default __webpack_public_path__ + "static/media/human.2f9dac3c.svg";